export const gtmPushEventAddToCart = (item: { name: string; variant: string; price: string; quantity: number; id: string }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "addToCart",
    ecommerce: {
      currencyCode: "GBP",
      add: {
        products: [item],
      },
    },
  });
};
